import { PlotMenu } from "./components/PlotMenu";
import { EncuestasChart } from "./components/EncuestasChart";
import { Row, Col, Space} from 'antd';
import React, { useEffect, useState } from "react";

import 'antd/dist/antd.min.css';


function App() {

  // States
  const [totalData, setTotalData] = useState({datasets: [{data: []},{data: []}], labels: []});
  const [chartData, setChartData] = useState({datasets: [{data: []},{data: []}], labels: []});
  const [encuestas, setEncuestas] = useState([])
  const [options, setOptions] = useState({})
  const [aprueboState, setAprueboState] = useState(true)
  const [rechazoState, setRechazoState] = useState(true)

  // Initial Setup
  // Carga datos de las encuestas, logo, y las options del gráfico
  useEffect(() => {

    const getDatos = async () => {
      const res = await fetch("https://d1uww442kixcfq.cloudfront.net/data_encuestas_v2.json")
      const data = await res.json()
      const image = new Image();
      image.crossOrigin = "anonymous";  // This enables CORS
      image.src = 'https://d1uww442kixcfq.cloudfront.net/encuestas/imgs/logo2.png';

      setTotalData(data);
      setOptions({interaction: {
                            intersect: false,
                            mode: 'point',
                          },
                  responsive: true,
                  layout: {
                    padding: {
                      right: function(ctx){
                        if (ctx.chart.width < 800){
                          return 50
                        }
                        return 200
                      },
                      top: function(ctx){
                        if (ctx.chart.width < 800){
                          return 30
                        }
                        return 45
                      }
                    }
                  },
                  maintainAspectRatio: false,
                  plugins: {
                    corsair: {
                    horizontal: false,
                    vertical: true,
                    color: 'gray',
                    dash: [],
                    width: 0.4
                      },

                    legend: {
                      display: false,
                      position: 'top',
                      align: 'start'
                    },
                    title: {
                      display: false,
                      text: 'Apruebo y Rechazo según las encuestas'
                      },
                    datalabels:{
                      textStrokeColor: 'white',
                      textStrokeWidth: 3,
                      color: 'black',
                      font: function(context) {
                            var width = context.chart.width;
                            var size = 9 + Math.round(width / 300);
                              return {
                                size: size,
                                weight: 'bold'
                              };
                          },
                      formatter: function(value, context) {
                        return null
                        
                      },
                      display: function(context) {
                          return (context.dataIndex === context.dataset.data.length - 1);
                        }
                    },
                    tooltip:{
                      callbacks:{
                          afterBody: function(item) {
                            let encuestaString = ""
                            if (item.length > 0){
                              item.forEach((value, idx) => {
                                let encuestas = value.chart.config._config.options.labels_encuesta
                                let encuesta = encuestas[value.dataIndex]
                                if (value.dataset.type === "scatter"){
                                  if (idx < item.length - 1){
                                    encuestaString += `Encuesta: ${encuesta}
`
                                  }
                                  else{
                                    encuestaString += `Encuesta: ${encuesta}`
                                  }
                                  
                                }
                              })

                              if (encuestaString.length === 0){
                                return null
                              }
                              else{
                                return encuestaString
                              }
                            }
                          } 
                        },
                        filter: function (tooltipItem) {
                          
                          let label = tooltipItem.dataset.label;
                          
                          if ((label === "Apruebo") || (label === "Rechazo")) {
                            return true;
                          } else {
                            return false;
                          }
                          }
                    }
                    
                  },
                  scales: {
                      x: {
                        title: {
                          display: true,
                          text: 'Fecha',
                          font: function(context) {
                            var width = context.chart.width;
                            var size = 10 + Math.round(width / 300);
                              return {
                                size: size
                              };
                          }
                        },
                      ticks: {
                        maxTicksLimit: function(ctx){
                          if (ctx.chart.width < 800){
                            return 8
                          }
                          return 12
                        },
                        maxRotation: 0,
                        minRotation: 0,
                        font: function(context) {
                            var width = context.chart.width;
                            var size = 8 + Math.round(width / 300);
                              return {
                                size: size
                              };
                          }
                      },
                      grid: {
                        display: false,
                        drawBorder: true,
                        drawOnChartArea: false,
                        drawTicks: true,
                        borderColor: 'black'
                      }
                      },
                      y: {
                        title: {
                          display: true,
                          text: 'Porcentaje',
                          font: function(context) {
                            var width = context.chart.width;
                            var size = 10 + Math.round(width / 300);
                              return {
                                size: size
                              };
                          }
                        },
                        min: 10,
                        max: 70,
                        ticks: {
                          callback: function(value) {
                            return value + "%"
                        },
                          beginAtZero: true,
                          stepSize: 10,
                          font: function(context) {
                            var width = context.chart.width;
                            var size = 8 + Math.round(width / 300);
                              return {
                                size: size
                              };
                          }
                          
                        },
                      grid: {
                        display: true,
                        drawBorder: true,
                        borderColor: 'black'
                        }
                    }
                  },
                  labels_encuesta: data["labels_encuesta"], // Almacenar opts extra para usar en plugins
                  img_decidechile: image
                  })

    setChartData({
            labels: data["labels"],
            mode_all: true,
            datasets: [
          {
            label: "Rechazo bottom",
            type: "line",
            backgroundColor: 'rgba(255, 58, 59, 0.1)',
            borderColor: 'rgba(255, 58, 59, 0)',
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: +2,
            tension: 0.5,
            data: data["rechazo_bottom"],
            yAxisID: 'y',
            xAxisID: 'x',
            active: true
          },
          {
            label: "Rechazo mean",
            type: "line",
            backgroundColor: 'rgba(255, 58, 59, 1)',
            borderColor: 'rgba(255, 58, 59, 1)',
            hoverBorderColor: 'rgba(255, 58, 59, 1)',
            fill: false,
            tension: 0.5,
            pointRadius: 0,
            pointHoverRadius: 0,
            data: data["rechazo"],
            yAxisID: 'y',
            xAxisID: 'x',
            active: true,
            datalabels: {
              anchor: 'start',
              align: -125,
              clamp: true,
              padding: 5,
              borderRadius: 4,
            }
          },
          {
            label: "Rechazo top",
            type: "line",
            backgroundColor: 'rgba(255, 58, 59, 0.1)',
            borderColor: 'rgba(255, 58, 59, 0)',
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: 0,
            tension: 0.5,
            data: data["rechazo_top"],
            yAxisID: 'y',
            xAxisID: 'x',
            active: true
          },
          {
            label: "Apruebo bottom",
            type: "line",
            backgroundColor: 'rgba(0, 169, 209, 0.2)',
            borderColor: 'rgba(0, 169, 209, 0)',
            pointRadius: 0,
            pointHoverRadius: 0.0,
            fill: +3,
            tension: 0.5,
            data: data["apruebo_bottom"],
            yAxisID: 'y',
            xAxisID: 'x',
            active: true
          },
          {
            label: "Apruebo mean",
            type: "line",
            backgroundColor: 'rgba(0, 169, 209, 1)',
            borderColor: 'rgba(0, 169, 209, 1)',
            hoverBorderColor: 'rgba(0, 169, 209, 1)',
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: false,
            tension: 0.5,
            data: data["apruebo"],
            yAxisID: 'y',
            xAxisID: 'x',
            datalabels: {
              anchor: 'start',
              align: -240,
              padding: 5,
              borderRadius: 4,
            },
            active: true
          },
          {
            label: "Apruebo top",
            type: "line",
            backgroundColor: 'rgba(0, 169, 209, 0.2)',
            borderColor: 'rgba(0, 169, 209, 0)',
            pointRadius: 0,
            pointHoverRadius: 0,
            fill: +3,
            tension: 0.5,
            data: data["apruebo_top"],
            yAxisID: 'y',
            xAxisID: 'x',
            active: true
          },
          
          {
            label: "Apruebo",
            type: "scatter",
            data: data["apruebo_scatter"],
            backgroundColor: 'rgba(0, 169, 209, 0.6)',
            borderColor: 'rgba(0, 169, 209, 0.6)',
            hoverBorderColor: 'rgba(0, 169, 209, 0.6)',
            pointRadius: 3,
            pointHoverRadius: 5,
            active: true
          },
          
          {
            label: "Rechazo",
            type: "scatter",
            data: data["rechazo_scatter"],
            backgroundColor: 'rgba(255, 58, 59, 0.6)',
            borderColor: 'rgba(255, 58, 59, 0.6)',
            hoverBorderColor: 'rgba(255, 58, 59, 0.6)',
            pointRadius: 3,
            pointHoverRadius: 5,
            active: true
          } 
        ]
              });

      setEncuestas(["Todas las encuestas", ...new Set(data["labels_encuesta"])])
        
      }

    getDatos();
    
  }
    ,[])

  // UseEffect para las legendas apruebo y rechazo
  useEffect(() => {
    if (aprueboState){
        setChartData(c => {
          let new_data = {...c,
            datasets: [...c.datasets.slice(0,3), 
              { ...c.datasets[3],
            backgroundColor: 'rgba(0, 169, 209, 0.2)',
            active: true},
            { ...c.datasets[4],
            backgroundColor: 'rgba(0, 169, 209, 1)',
            borderColor: 'rgba(0, 169, 209, 1)',
            active: true},
            { ...c.datasets[5],
            backgroundColor: 'rgba(0, 169, 209, 0.2)',
            active: true},
            { ...c.datasets[6],
            backgroundColor: 'rgba(0, 169, 209, 0.6)',
            borderColor: 'rgba(0, 169, 209, 0.6)',
            pointRadius: 3,
            pointHoverRadius: 5,
            active: true},
            c.datasets[7]
          ]}
          return new_data
        })
    }else{
        setChartData(c => {
        let new_data = {...c,
        datasets: [...c.datasets.slice(0,3), 
          { ...c.datasets[3],
        backgroundColor: 'rgba(0, 169, 209, 0)',
        borderColor: 'rgba(0, 169, 209, 0)',
        active: false},
        { ...c.datasets[4],
        backgroundColor: 'rgba(0, 169, 209, 0)',
        borderColor: 'rgba(0, 169, 209, 0)',
        active: false},
        { ...c.datasets[5],
        backgroundColor: 'rgba(0, 169, 209, 0)',
        borderColor: 'rgba(0, 169, 209, 0)',
        active: false},
        { ...c.datasets[6],
        backgroundColor: 'rgba(0, 169, 209, 0)',
        borderColor: 'rgba(0, 169, 209, 0)',
        pointRadius: 0,
        pointHoverRadius: 0,
        active: false},
        c.datasets[7]
        ]}
        return new_data
        })
    }
  }, [aprueboState])

  useEffect(() => {
    if (rechazoState){
        setChartData(c => {
          let new_data = {...c,
        datasets: [{...c.datasets[0], 
        backgroundColor: 'rgba(255, 58, 59, 0.1)',
        active: true}, 
        {...c.datasets[1], 
        backgroundColor: 'rgba(255, 58, 59, 1)',
        borderColor: 'rgba(255, 58, 59, 0.6)',
        active: true}, 
        {...c.datasets[2], 
        backgroundColor: 'rgba(255, 58, 59, 0.1)',
        active: true}, 
        ...c.datasets.slice(3,7),
        {...c.datasets[7], 
        backgroundColor: 'rgba(255, 58, 59, 0.6)',
        pointRadius: 3,
        pointHoverRadius: 5,
        borderColor: 'rgba(255, 58, 59, 0.6)',
        active: true}]}
          return new_data
        })
    }else{
        setChartData(c => {
          let new_data = {...c,
        datasets: [{...c.datasets[0], 
        backgroundColor: 'rgba(255, 58, 59, 0)',
        borderColor: 'rgba(255, 58, 59, 0)',
        active: false}, 
        {...c.datasets[1], 
        backgroundColor: 'rgba(255, 58, 59, 0)',
        borderColor: 'rgba(255, 58, 59, 0)',
        active: false}, 
        {...c.datasets[2], 
        backgroundColor: 'rgba(255, 58, 59, 0)',
        borderColor: 'rgba(255, 58, 59, 0)',
        active: false}, 
        ...c.datasets.slice(3,7),
        {...c.datasets[7], 
        backgroundColor: 'rgba(255, 58, 59, 0)',
        pointRadius: 0,
        pointHoverRadius: 0,
        borderColor: 'rgba(255, 58, 59, 0)',
        active: false}]}
          return new_data
        })
    }
  }, [rechazoState])

  function handleLegend (e) {
    e.preventDefault()
    if (e.target.name === "apruebo" || e.target.id === "apruebo"){
        setAprueboState(!aprueboState)
        document.getElementById("apruebo").classList.toggle('clicked')
    }

    if (e.target.name === "rechazo" || e.target.id === "rechazo"){
        setRechazoState(!rechazoState)
        document.getElementById("rechazo").classList.toggle('clicked');
    }
    }
  

  function handleDownload (e) {

    function download_image(id_element){
        let url_base64 = document.getElementById(id_element).toDataURL('image/png');
        let a = document.createElement("a"); //Create <a>
        a.href = url_base64; //Image Base64 Goes here
        a.download = "Encuestas_AR.png"; //File name Here
        a.click(); //Downloaded file
    }

    e.preventDefault()
    download_image('encuestasChart')
  }

  function handleEncuesta (e) {
    let index_encuesta = ["dummy", ...totalData['labels_encuesta']].map((a,i) => a === e ? (i-1).toString() : undefined).filter(x => x)
    if (e === "Todas las encuestas"){
      setChartData(c => {
      return {...c, 
        datasets: [
                    {...c.datasets.at(0), data: totalData["rechazo_top"]},
                    {...c.datasets.at(1), data: totalData["rechazo"]},
                    {...c.datasets.at(2), data: totalData["rechazo_bottom"]},
                    {...c.datasets.at(3), data: totalData["apruebo_top"]},
                    {...c.datasets.at(4), data: totalData["apruebo"]},
                    {...c.datasets.at(5), data: totalData["apruebo_bottom"]},
                    {...c.datasets.at(6), data: totalData["apruebo_scatter"], type: "scatter", 
                      backgroundColor: 'rgba(0, 169, 209, 0.6)',
                      borderColor: 'rgba(0, 169, 209, 0.6)',
                      hoverBorderColor: 'rgba(0, 169, 209, 0.6)'},
                    {...c.datasets.at(7), data: totalData["rechazo_scatter"], type: "scatter",
                      backgroundColor: 'rgba(255, 58, 59, 0.6)',
                      borderColor: 'rgba(255, 58, 59, 0.6)',
                      hoverBorderColor: 'rgba(255, 58, 59, 0.6)'}
                  ]
      
        }
      })
    }
    else{
      setChartData(c => {
      return {...c, 
        datasets: [
                    {...c.datasets.at(0), data: []},
                    {...c.datasets.at(1), data: []},
                    {...c.datasets.at(2), data: []},
                    {...c.datasets.at(3), data: []},
                    {...c.datasets.at(4), data: []},
                    {...c.datasets.at(5), data: []},
                    {...c.datasets.at(6), data: index_encuesta.map(x=>totalData["apruebo_scatter"][parseInt(x)]), type: "line", tension: 0.3,
                      backgroundColor: 'rgba(0, 169, 209, 0.6)',
                      borderColor: 'rgba(0, 169, 209, 0.6)',
                      hoverBorderColor: 'rgba(0, 169, 209, 0.6)'},
                    {...c.datasets.at(7), data: index_encuesta.map(x=>totalData["rechazo_scatter"][parseInt(x)]), type: "line", tension: 0.3,
                      backgroundColor: 'rgba(255, 58, 59, 0.6)',
                      borderColor: 'rgba(255, 58, 59, 0.6)',
                      hoverBorderColor: 'rgba(255, 58, 59, 0.6)'}
                  ]
      
        }
      })
    }
    
  }


  return (
    <div className="App">
      <Space direction="vertical" size={2} style={{ display: 'flex' }}>
        <Row>
          <Col xs={{span: 20, offset: 4}} md={{span: 20, offset: 4}}>
            <PlotMenu encuestas = {encuestas} handleLegend={handleLegend} handleDownload={handleDownload} handleEncuesta={handleEncuesta}/>
          </Col>
        </Row>

        <Row>
          <Col xs={{span: 22, offset: 1}} md={{span: 20, offset: 3}}>
            {Object.keys(options).length > 0 ? <EncuestasChart chartData={chartData} options={options} /> : <div></div>}
            
          </Col>
        </Row>
      </Space>
    </div>
  );
}

export default App;
